<template>
  <div class="content-continer peview">
    <div class="right close-peview" @click="closePeview">关闭预览</div>
    <ul style="margin-top:50px;margin-bottom: 100px;position: relative;" id="table">
      <li>
        <div class="left peview-img">
          <img :src="imgurl+personlist.workImgUrl" style="height:120px;" />
        </div>
        <div class="left">
          <p class="peview-name">{{personlist.cnName}}</p>
          <p class="peview-xq">
            <span>
              <img src="../assets/phone.png" />
              {{personlist.mobile}}
            </span>
            <span>
              <img src="../assets/old.png" />
              {{personlist.age}}岁
            </span>
            <span>
              <img src="../assets/address.png" />
              {{personlist.city}}
            </span>
          </p>
        </div>
        <div style="clear:both"></div>
      </li>
      <!-- 教育经历************************************************************************ -->
      <li>
        <div class="peview-list-title">教育经历</div>
        <ul>
          <li v-for="(item,index) in personlist.eduList" :key="index">
            <div class="peview-list-title-name">{{item.schoolName}}</div>
            <div class="peview-list-ed-msg">
              <span>{{item.startDate}}/{{item.endDate}}</span>|
              <span>{{item.eduLevelDesc}}</span>|
              <span v-if="item.isGeneral==1">统招</span>
              <span v-if="item.isGeneral==0">自考</span>|
              <span>{{item.majorName}}</span>
            </div>
          </li>
        </ul>
        <ul v-if="personlist.eduList==''">
          <li>暂无数据</li>
        </ul>

        <img src="../assets/geren-icon1.png" class="peview-b-icon" />
      </li>
      <!-- 培训经历***************************************************************************** -->
      <li>
        <div class="peview-list-title">培训经历</div>
        <ul>
          <li v-for="(item,index) in personlist.trainList" :key="index">
            <div class="peview-list-title-name">{{item.schoolName}}</div>
            <div class="peview-list-ed-msg">
              <span>{{item.startDate}}/{{item.endDate}}</span>|
              <span>{{item.courseName}}</span>
            </div>
          </li>
        </ul>
        <ul v-if="personlist.trainList==''">
          <li>暂无数据</li>
        </ul>
        <img src="../assets/geren-icon1.png" class="peview-b-icon" />
      </li>
      <!-- 获得证书************************************************************************************* -->
      <li>
        <div class="peview-list-title">获得证书</div>
        <ul>
          <li v-for="(item,index) in personlist.certificateList" :key="index">
            <div class="peview-list-title-name">{{item.certificateName}}</div>
            <div class="peview-list-ed-msg">
              <span>{{item.getTime}}</span>|
              <span>{{item.certificateName}}</span>
            </div>
          </li>
        </ul>
        <ul v-if="personlist.certificateList==''">
          <li>暂无数据</li>
        </ul>
        <img src="../assets/geren-icon1.png" class="peview-b-icon" />
      </li>
      <!-- 项目经历******************************************************************************************* -->
      <li>
        <div class="peview-list-title">项目经历（个人备案）</div>
        <img src="../assets/geren-icon1.png" class="peview-b-icon" />
        <ul>
          <li v-for="(item,index) in personlist.projectExpList0" :key="index">
            <div class="peview-list-title-name">{{item.projectName}}</div>
            <div class="peview-list-ed-msg">
              <span>{{item.startDate}}/{{item.endDate}}</span>|
              <span>{{item.specialtyName}}</span>
            </div>
            <ul class="peview-item">
              <li>
                <p>公司名称</p>
                <p>{{item.smoName?item.smoName:'无'}}</p>
              </li>
              <li>
                <p>专业名称</p>
                <p>{{item.specialtyName?item.specialtyName:'无'}}</p>
              </li>
              <li>
                <p>职位名称</p>
                <p>CRC</p>
              </li>
              <li>
                <p>项目类型</p>
                <p>{{item.phaseDesc?item.phaseDesc:'无'}}</p>
              </li>
              <li>
                <p>证明人</p>
                <p>{{item.managerName?item.managerName:'无'}}</p>
              </li>
              <li>
                <p>证明人电话</p>
                <p>{{item.managerMobile?item.managerMobile:'无'}}</p>
              </li>
              <li style="display:block;" v-if="item.workDesc">
                <p>项目描述</p>
                <p>{{item.workDesc}}</p>
              </li>
            </ul>
          </li>
        </ul>
        <ul v-if="personlist.projectExpList0==''">
          <li>暂无数据</li>
        </ul>
      </li>
      <li>
        <div class="peview-list-title">项目经历(公司备案)</div>
        <img src="../assets/geren-icon2.png" class="peview-b-icon" />
        <img src="../assets/chapter.png" style="position: absolute;right: 110px;" v-if="personlist.projectExpList1!=''"/>
        <ul>
          <li v-for="(item,index) in personlist.projectExpList1" :key="index">
            <div class="peview-list-title-name">
              {{item.projectName}}
              <span v-if="item.projectState=='2'" class="projectState">进行中</span>
            </div>
            <div class="peview-list-ed-msg">
              <span>{{item.startDate}}/{{item.endDate}}</span>|
              <span>{{item.specialtyName}}</span>
            </div>
            <ul class="peview-item">
              <li>
                <p>公司名称</p>
                <p>{{item.smoName?item.smoName:'无'}}</p>
              </li>
              <li>
                <p>专业名称</p>
                <p>{{item.specialtyName?item.specialtyName:'无'}}</p>
              </li>
              <li>
                <p>职位名称</p>
                <p>CRC</p>
              </li>
              <li>
                <p>项目类型</p>
                <p>{{item.phaseDesc?item.phaseDesc:'无'}}</p>
              </li>
              <li>
                <p>负责人</p>
                <p>{{item.managerName?item.managerName:'无'}}</p>
              </li>
              <li>
                <p>负责人电话</p>
                <p>{{item.managerMobile?item.managerMobile:'无'}}</p>
              </li>
              <li style="display:block;" v-if="item.workDesc">
                <p>项目描述</p>
                <p>{{item.workDesc}}</p>
              </li>
              <li style="display:block;">
                <p>工作评价</p>
                <p style="color:#999">
                  星级：
                  <el-rate
                    v-model="item.starNum"
                    disabled
                    text-color="#4D4D4D"
                    style="display:inline"
                    score-template="{item.starNum}"
                    :colors="colors"
                    disabled-void-color="#999"
                  >></el-rate>
                </p>
                <p>评语：{{item.evaluate?item.evaluate:'无'}}</p>
              </li>
            </ul>
          </li>
        </ul>
        <ul v-if="personlist.projectExpList1==''">
          <li>暂无数据</li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { preview } from "@/request/api";
import Watermark from "../js/watermark.js";

export default {
  data() {
    return {
      personlist: {},
      imgurl: this.Common.imgurl,
      colors: ["#f00", "#f00", "#f00"] // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
    };
  },
  // 获取父元素传过来的ID值
  props: ["childid"],
  // watch: {
  //   personlist: function() {
  //     this.$nextTick(function() {
  //       Watermark.set("临床CRC可信服务平台");
  //       // alert(document.getElementById("table").clientHeight);
  //     });
  //   }
  // },
  methods: {
    closePeview() {
      this.$emit("peviewstatus", false);
    }
  },
  mounted() {
    // alert(this.childid);
    preview(this.childid)
      .then(res => {
        console.log(res.data.data);
        this.personlist = res.data.data;
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.peview ul li li {
  margin-bottom: 20px;
}
.projectState {
  display: inline-block;
  color: #3672bf;
  width: 56px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
  margin-left: 20px;
  background: rgba(224, 238, 254, 1);
  border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/preview.vue